import { invoke, getQueryClient } from "@blitzjs/rpc"
import { useSession } from "@blitzjs/auth"
import { Button } from "app/core/components/Button"
import stopImpersonating from "app/auth/mutations/stopImpersonating"

export const ImpersonatingUserNotice = () => {
  const session = useSession({ suspense: false })

  if (!session.impersonatingFromUserId) return null

  return (
    <div className="bg-yellow-400 px-2 py-1 text-center font-semibold">
      Currently impersonating user {session.userId}{" "}
      <Button
        color="transparent"
        textColor="black"
        onClick={async () => {
          await invoke(stopImpersonating, {})
          getQueryClient().clear()
        }}
      >
        EXIT
      </Button>
    </div>
  )
}
